import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"

export default class extends Controller {
  connect() {
    const slideCount = this.element.querySelectorAll(".swiper-slide").length
    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination],
      autoHeight: true,
      loop: slideCount > 1,
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
        clickable: true,
      },
    })
  }

  disconnect() {
    this.swiper?.destroy(true, true)
  }
}
